<template>
  <div class="experiences-filter-container container">
    <div class="heading-wrapper">
      <h2 class="heading-title">
        <span>{{ title }}</span>
      </h2>
    </div>
    <experiences-list
      :options="options"
      :experiences="items"
      :categories="categories"
      :dictionary="dictionary"
      :is-scrollable="isScrollable"
    />
  </div>
</template>

<script>
  import ExperiencesList from './experiences-list.vue'

  export default {
    name: 'Experiences',
    components: {
      ExperiencesList
    },
    props: {
      experiencesData: {
        type: Object,
        required: true,
        default: () => ({})
      },
      calendarLang: {
        type: Object,
        default: () => ({})
      },
      isScrollable: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        categories: [],
        items: [],
        options: {},
        dictionary: {}
      }
    },
    computed: {
      title() {
        return this.experiencesData.title
      }
    },
    created() {
      this.getData()
    },
    methods: {
      getData() {
        this.items = this.experiencesData.experiences
        this.options = {
          showExclusiveSetting: this.experiencesData.showExclusiveSetting,
          eyebrowSource: this.experiencesData.eyebrowSource,
          categoryTabsOrder: this.experiencesData.orderOfCategoryTabs,
          regionSectionsOrder: this.experiencesData.orderOfRegionSections,
          seasonsOrder: this.experiencesData.orderOfSeasons,
          calendarLang: this.calendarLang,
        }
        this.dictionary = this.experiencesData.dictionary
        this.categories = this.getExperincesCategories(this.items)
      },
      getExperincesCategories(experiences) {
        const uniqueCategoriesObject = {}
        const remainingCategories = []
        const reorderedCategories = []

        experiences.forEach((item) => {
          item.categories.forEach((category) => {
            const categoryId = category.id
            if (!uniqueCategoriesObject[categoryId]) {
              uniqueCategoriesObject[categoryId] = category
            }
          })
        })

        const uniqueCategories = Object.values(uniqueCategoriesObject)
        if (this.options.categoryTabsOrder) {
          this.options.categoryTabsOrder.forEach((item) => {
            const category = uniqueCategories.find(
              (uniqueCategory) => uniqueCategory.id === item.id
            )
            if (category) {
              reorderedCategories.push(category)
            }
          })

          uniqueCategories.forEach((category) => {
            if (!reorderedCategories.includes(category)) {
              remainingCategories.push(category)
            }
          })
          return [...reorderedCategories, ...remainingCategories]
        }
        return uniqueCategories
      }
    }
  }
</script>
